import { defineStore } from 'pinia'

export interface HelpContent {
  title?: string
  helpText?: string
  imgSrc?: string
  docsLink?: string
}

interface HelpState {
  isOpen: boolean
  activeKey: string | null
  content: HelpContent
}

export const useHelpStore = defineStore('help', {
  state: (): HelpState => ({
    isOpen: false,
    activeKey: null,
    content: {}
  }),

  actions: {
    open(key: string, content: HelpContent) {
      this.activeKey = key
      this.content = content
      this.isOpen = true
    },

    close() {
      this.isOpen = false
      this.activeKey = null
      this.content = {}
    },

    toggle(key: string, content: HelpContent) {
      if (this.isOpen && this.activeKey === key) {
        this.close()
      } else {
        this.open(key, content)
      }
    }
  }
})
